import React from 'react';
import { CloudUploadRounded, KeyboardArrowDownRounded } from '../../utils/constants';
import {ImageBuffer} from '../';

import './formField.css'

interface Person {
  _id: string;
  firstName: string;
  lastName: string;
  selectedFile?: string;
  name?: string;
  value?: string;
  hint?: string;
}

interface FormFieldProps {
  // Add all the actual types for your props here
  isLoadingBtn?: boolean;
  isValid?: boolean;
  inputTypeHidden?: boolean;
  labelBoolean?: boolean;
  labelName?: string;
  selectedLabelName?: string;
  labelTitle?: React.ReactNode;
  name?: string;
  id?: string;
  accept?: string;
  type?: string;
  value?: string;
  handleChange?: (e: React.ChangeEvent<any>) => void;
  handleBlur?: (e: React.FocusEvent<any>) => void;
  inputType?: boolean;
  selectMenu?: boolean;
  selectedFileName?: string;
  fileInputType?: boolean;
  multipleFileInputType?: boolean;
  selectType?: boolean;
  textareaType?: boolean;
  readOnly?: boolean;
  maxLength?: number;
  placeholder?: string;
  fullNameOption?: boolean;
  valueOptionId?: boolean;
  radioType?: boolean;
  htmlFor?: string;
  checked?: boolean;
  errors?: string[];
  options?: any[];
  data?: Person[];
  min?: string | number;
  max?: string | number;
  defaultValue?: string;
  dropdownState?: boolean;
  onChange?: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => void;
  onBlur?: (e: React.FocusEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => void;
  onClick?: () => void;
  menuClick?: (id: string, firstName?: string, lastName?: string) => void;
  renderOption?: (option: any) => { value: string; label: string };
  menuOption?: string;
}

const FormField = ({isLoadingBtn, isValid, inputTypeHidden, labelBoolean, labelName, selectedLabelName, labelTitle, name, id, accept, type, value, onChange, handleChange, handleBlur, inputType, selectedFileName, selectMenu, fileInputType, placeholder, multipleFileInputType, selectType, textareaType, readOnly, maxLength, fullNameOption, valueOptionId, radioType, htmlFor, checked, errors, options=[], min, max, defaultValue, data, dropdownState, onClick, menuClick, renderOption, menuOption}: FormFieldProps) => {

  return (
    <>
      <div className='reg-input-group'>
          {inputType ? (
            <>
              <input
                name={name}
                type={type}
                value={value}
                accept={accept}
                onChange={handleChange}
                onBlur={handleBlur}
                required
                autoComplete='off'
                className='reg-input'
                placeholder={placeholder}
                readOnly={readOnly}
                min={min}
                max={max}
                defaultValue={defaultValue}
                maxLength={maxLength}
              />
            </>
          ) : inputTypeHidden ? (
            <input name={name} type="hidden" value={value} />
          ) : selectMenu ? (
            <>
              <div className="select-menu-wrapper">
                <div className="select-menu">
                  <div className="select-btn" onClick={onClick}>
                    <span className="btn-text">{menuOption ? menuOption : `select a ${name}`}</span>
                    <KeyboardArrowDownRounded />
                  </div>

                  <ul className={dropdownState ? 'options active' : 'options'}>
                    <li className="option" onClick={() => menuClick?.('')}>
                      <span className="option-text"> -- select a {name}</span>
                    </li>
                    {data?.map((detail, index) => (
                      <li key={index} className="option" onClick={() => menuClick?.(detail._id, detail.firstName, detail.lastName)}>
                        <div className="img-cover">
                          <ImageBuffer src={detail.selectedFile} alt='img' index={index} />
                        </div>
                        <span className="option-text">{detail.firstName} {detail.lastName}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </>
          ) : fileInputType ? (
            <>
              <label htmlFor={name} className='reg-input-file-wrapper' title='upload a file'>
                <input id={name} type="file" accept={accept} required name={name} onChange={handleChange} hidden />
                <div className='reg-input-file-icon'><CloudUploadRounded /></div>
                <span>{selectedFileName || selectedLabelName}</span>
              </label>
            </>
          ) : multipleFileInputType ? (
            <>
              <label htmlFor='reg-input-multiple-file' className='reg-input-file-wrapper' title='upload multiple files'>
                <input id="reg-input-multiple-file" type="file" accept={accept} multiple max="10" required name={name} onChange={handleChange} hidden />
                <div className='reg-input-file-icon'><CloudUploadRounded /></div>
                <span>{selectedFileName || selectedLabelName}</span>
              </label>
            </>
          ) : selectType ? (
              <select required className='reg-input-select-group' name={name} value={value} onChange={handleChange} onBlur={handleBlur}>
                <option value=""></option> 
                {/* this enables flexible and selective rendering */}
                {Array.isArray(options) && options.length > 0 ? (
                  options.map((option, index) => {
                    const opt = renderOption
                      ? renderOption(option)
                      : {
                          value: fullNameOption
                            ? valueOptionId
                              ? option._id
                              : `${option._id}`
                            : option.value,
                          label: fullNameOption
                            ? `${option.firstName || ''} ${option.lastName || ''} ${option.name || ''}`
                            : `${option.name || ''} ${option.hint || ''} ${option.title || ''} ${option.storeId || ''}`,
                        };

                    return (
                      <option key={index} value={opt.value}>
                        {opt.label}
                      </option>
                    );
                  })
                ) : (
                  <option disabled value="">
                    No options available
                  </option>
                )}
              </select>
          ) : textareaType ? (
              <textarea required className='reg-textarea-select-group' name={name} value={value} onChange={handleChange} onBlur={handleBlur} maxLength={maxLength}></textarea>
          ) : radioType ? (
              <label htmlFor={htmlFor} className='reg-input-label-radio'>
                <input type={type} name={name} id={id} value={value} className='reg-input-radio__input' checked={checked} onChange={onChange} onBlur={handleBlur} />
                <div className='reg-input-radio__radio'></div>
                {labelTitle}
              </label>
          ) : null}

          {!labelBoolean && (
            <label htmlFor={name} className="reg-input-label">
              {labelName}
            </label>
          )}
        {isLoadingBtn && (
          <div className="spinner loading"></div>
        )}
      </div>
      <div className={isValid ? 'validation invalid' : 'validation'}>
        {errors}
      </div>
    </>
  )
}

export default FormField